<app-headline-page>
  {{ pageHeader | i18next }}
</app-headline-page>

<app-card>
  @if (!!icon) {
    <app-fa-icon class="d-flex mb-3 mx-auto" [icon]="icon" size="3xl"></app-fa-icon>
  }

  @if (!!cardHeader) {
    <app-headline-content
      class="d-flex mx-auto">
      {{ cardHeader | i18next }}
    </app-headline-content>
  }

  <div class="mx-auto text-center" [innerHTML]="text | i18next"></div>
</app-card>

@if (!!buttonText) {
  <div
    class="d-flex justify-content-end mt-3">
    <button class="btn btn-outline-primary" (click)="next.emit()">
      {{ buttonText | i18next }}
    </button>
  </div>
}

